export enum PaymentMethodCode {
  CREDIT_CARD = 'CREDIT_CARD',
  NEW_CREDIT_CARD = 'NEW_CREDIT_CARD',
  EXISTING_CREDIT_CARD = 'EXISTING_CREDIT_CARD',
  ONE_TIME_CREDIT_CARD = 'ONE_TIME_CREDIT_CARD',
  FAST_TRANSFER = 'FAST_TRANSFER',
  BLIK = 'BLIK',
  TWISTO = 'TWISTO',
  ING = 'ING',
  DEFER = 'DEFER',
  AUTO_PAYMENT = 'AUTO_PAYMENT',
}
